export default "/_next/static/assets/default-landing-header-image_cb81a1340cd62d1423dcfe9a75aeada1.webp";